import React from 'react';
import styled from 'styled-components';
import { Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { panelTheme } from '../PanelComerciales.theme';

interface DrawerShellProps {
    open: boolean;
    title: string;
    description?: string;
    onClose: () => void;
    children: React.ReactNode;
    width?: number;
}

const Body = styled.div`
    padding: 16px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    height: 100%;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid ${panelTheme.colors.border};

    .stack {
        display: flex;
        flex-direction: column;
    }
    h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: ${panelTheme.colors.text};
    }
    p {
        margin: 4px 0 0;
        font-size: 12px;
        color: ${panelTheme.colors.textMuted};
    }
`;

const DrawerShell: React.FC<DrawerShellProps> = ({
    open,
    title,
    description,
    onClose,
    children,
    width = 420,
}) => (
    <Drawer
        anchor='right'
        open={open}
        onClose={onClose}
        PaperProps={{
            sx: {
                width: { xs: '100%', sm: width },
            },
        }}
    >
        <Header>
            <div className='stack'>
                <Typography component='h4'>{title}</Typography>
                {description ? <p>{description}</p> : null}
            </div>
            <IconButton onClick={onClose} size='small'>
                <CloseIcon fontSize='small' />
            </IconButton>
        </Header>
        <Body>{children}</Body>
    </Drawer>
);

export default DrawerShell;
